<template>
  <gmap
    :containerHeight="`${container_height}px`"
    :height="`${container_height}px`"
    :center="mapCenter"
    :markerIconOptions="{
      size: 20,
      url: getIcon(),
    }"
    :zoom="15"
    @mapReady="handleMapReady"
    @showEditMapModal="showEditMapModal"
    :options="options"
  >
  </gmap>
</template>

<script>
import Gmap from "./Map";

export default {
  components: {
    gmap: Gmap,
  },

  props: {
    location: {
      type: Object,
      required: true,
    },
    container_height: {
      type: Number,
      required: false,
      default: 208,
    },
  },

  data: () => ({
    options: {
      zoomControl: false,
      scaleControl: false,
      fullscreenControl: false,
    },
  }),

  computed: {
    mapCenter() {
      return {
        lat: parseFloat(this.location.latitude),
        lng: parseFloat(this.location.longitude),
      };
    },
  },

  mounted() {},

  methods: {
    getIcon() {
      return `/assets/svgs/marker.svg`;
    },

    handleMapReady(map, google) {
      this.map = map;
      this.google = google;
      this.mapReady = true;
    },

    showEditMapModal() {
      this.$emit("showEditMapModal");
    },
  },
};
</script>
